import { render, staticRenderFns } from "./Gateway.vue?vue&type=template&id=db6fa128&scoped=true"
import script from "./Gateway.vue?vue&type=script&lang=js"
export * from "./Gateway.vue?vue&type=script&lang=js"
import style0 from "./Gateway.vue?vue&type=style&index=0&id=db6fa128&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6fa128",
  null
  
)

export default component.exports